const DIRECT_DEPOSIT_VETERAN_STATUS = {
  VETERAN: 'VETERAN',
  DEPENDENT: 'DEPENDENT',
  NEITHER_VETERAN_NOR_DEPENDENT: 'NEITHER_VETERAN_NOR_DEPENDENT',
  COULD_NOT_DETERMINE_DUE_TO_EXCEPTION: 'COULD_NOT_DETERMINE_DUE_TO_EXCEPTION',
};

module.exports = DIRECT_DEPOSIT_VETERAN_STATUS;
